module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_9-f6e12d5236530d4236823ac15ba1e2f4.jpg";